"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgClone(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M20 0a1 1 0 011 1v12a1 1 0 01-1 1h-6v1a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1h6V1a1 1 0 011-1zm-4.9 8v2L19 7l-3.9-3v2H12V4H5v10h7V8z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Clone')(SvgClone);
//# sourceMappingURL=Clone.js.map